function isExternal(location) {
    const url = new URL(location, window.location.href);
    return url.host !== window.location.host;
}

export default function processLinks() {
    const linksElements = document.querySelectorAll('a');

    linksElements.forEach(async (element) => {
        const href = element.href;
        const useFancybox = element.dataset.fancybox;
        const useGroup = element.dataset.fancyboxGroup;
        const useIframe = element.dataset.iframe;

        if (useIframe !== undefined) {
            element.addEventListener("click", async function (event) {
                event.preventDefault();
                const Fancybox = await import("@/utils/fancybox.js");
                const fancybox = Fancybox.default;

                fancybox.show([
                    {
                        src: href,
                        type: "iframe",
                        preload: false
                    },
                ], {
                    mainClass: "no-paddings"
                });
            });
        } else if (useFancybox !== undefined) {
            element.addEventListener("click", async function (event) {
                event.preventDefault();
                const Fancybox = await import("@/utils/fancybox.js");
                const fancybox = Fancybox.default;

                if (useGroup) {
                    const elements = Array.from(window.document.querySelectorAll('[data-fancybox-group="' + useGroup + '"]'));
                    
                    const fancyboxElements = elements.map(function (galleryElement) {
                        return {
                            src: galleryElement.href,
                            type: "image",
                            preload: false,
                        };
                    });
                    
                    fancybox.show(fancyboxElements, {
                        startIndex: elements.indexOf(element)
                    });
                } else {
                    fancybox.show([
                        {
                            src: href,
                            type: "image",
                        preload: false,
                    },
                ]);
                }
            });

            /*
            const fancybox = await import("@/utils/fancybox.js");
            if (useGroup) {
                fancybox.default.bind('[data-fancybox-group="' + useGroup + '"]', {
                    groupAll: true,
                });
            } else {
                fancybox.default.bind(element);
            }
            */
        } else if (isExternal(href)) {
            element.setAttribute("rel", "nofollow");
            element.setAttribute("target", "_blank");
        }
    });
}
